import React from "react";

import { useSelector} from 'react-redux';

import styles from "./FacebookShareLink.module.css";

import mainIcon from './assets/facebook.svg'

const FacebookShareLink = () => {

    const shareData = useSelector((state) => state.visualizer.shareData);

    const facebookUrl = `https://www.facebook.com/dialog/feed?app_id=321265669277557&link=${encodeURIComponent(shareData.url)}&redirect_uri=${encodeURIComponent(shareData.url)}`;
    
    return (
        <a href={facebookUrl} target="_blank" rel="noopener noreferrer" aria-label="share to Facebook link" className={styles.mainIcon}>
            <img src={mainIcon} alt="facebook icon"/>
        </a>
    );
};

export default FacebookShareLink;